import {
  CREATESETTLEMENTREPORTPARTNER_SUCCESS,
  CREATESETTLEMENTREPORTPARTNER_FAILED,
  RESET_CREATESETTLEMENTREPORTPARTNER,
  LOADING_CREATESETTLEMENTREPORTPARTNER,
  NETWORK_ERROR_CREATESETTLEMENTREPORTPARTNER,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_CREATESETTLEMENTREPORTPARTNER:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case CREATESETTLEMENTREPORTPARTNER_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case CREATESETTLEMENTREPORTPARTNER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_CREATESETTLEMENTREPORTPARTNER:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_CREATESETTLEMENTREPORTPARTNER:
      return (state = initialState);
    default:
      return state;
  }
};
